import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import Repository from "../../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { deleteLinkRedirect } from "../../../api/ApiLinkRedirect";

const DeleteView = ({
  idItem,
  onSearch,
  onClose,
  setRowSelection,
}: DeleteProduct) => {
  const handleDeleteProduct = async () => {
    deleteLinkRedirect(idItem);
    onClose(onClose + 1);
    // onSearch();
    // setRowSelection && setRowSelection({});
    modals.closeAll();
  };

  return (
    <div>
      <Text size="24px">Bạn có chắc chắn muốn xóa UrlRedirect này ?</Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="red"
          onClick={handleDeleteProduct}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: number[];
  onClose: any;
  onSearch: () => void;
  setRowSelection?: (rowSelection: Record<string, boolean>) => void;
};

export default DeleteView;
